import {
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const commonStore = inject(CommonSignalStore);

  const sessionToken = commonStore.loginData()?.token; //getSessionToken();

  let modifiedReq: HttpRequest<unknown> = req;
  if (sessionToken) {
    if (req.body instanceof FormData) {
      modifiedReq = req.clone({
        headers: new HttpHeaders().set(
          "Authorization",
          `Bearer ${sessionToken}`
        ),
      });
    } else if (req.headers.get("Authorization")) {
      modifiedReq = req.clone({
        headers: new HttpHeaders()
          .set("Content-Type", "application/json")
          .set("Authorization", req.headers.get("Authorization") as string),
      });
    } else {
      modifiedReq = req.clone({
        headers: new HttpHeaders()
          .set("Content-Type", "application/json")
          .set("Authorization", `Bearer ${sessionToken}`),
      });
    }
  }

  return next(modifiedReq);
  // .pipe(
  //   map((event: HttpEvent<any>) => {
  //     if (event instanceof HttpResponse && event.body) {
  //       const encryptedResponse = encryptData(event.body);
  //       // Modify the response here
  //       const modifiedResponse = event.clone({
  //         body: encryptedResponse,
  //       });
  //       return modifiedResponse;
  //     }
  //     return event;
  //   })
  // );
};
